import { render } from "./Sector.vue?vue&type=template&id=4a2c5428"
import script from "./Sector.vue?vue&type=script&lang=js"
export * from "./Sector.vue?vue&type=script&lang=js"

import exportComponent from "E:\\server\\www\\kpowa-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__